export default __webpack_public_path__ + "static/media/skillinsight.144128eb.svg";